import React, { useMemo } from "react";

import { Executor } from "../../../../../../../services";
import { useTypedSelector } from "../../../../../../../redux/store";
import { getHumanReadableNameCellHelper } from "../../../../../../../utils/cellHelpers";
import { CellContentRoot } from "../../../../../../LightTable";
import Circle from "../../../../../../Circle";
import { Row } from "..";

const IsWorkingCellContent: React.FC<IsWorkingCellContent.Props> = ({
	item,
}) => {
	const language = useTypedSelector((state) => state.session.language);
	const _item: any = item;
	const content = useMemo(
		() => getHumanReadableNameCellHelper(_item?.schedule?.name, language),
		[_item?.schedule?.name, language],
	);

	return (
		<CellContentRoot
			alignItems="center"
			w="100%"
			h="100%"
			p="0"
			cursor="pointer"
		>
			<Row active={item.active}>
				{
					<div
						style={{
							display: "flex",
							alignItems: "center",
							padding: "0px",
						}}
					>
						{item?.isWorking ? (
							<Circle color="rgb(76, 175, 80)" />
						) : (
							<Circle />
						)}
						<span style={{ marginLeft: 8 }}>{content}</span>
					</div>
				}
			</Row>
		</CellContentRoot>
	);
};

declare namespace IsWorkingCellContent {
	interface Props {
		item: Executor.Model;
	}
}

export default React.memo(IsWorkingCellContent);
